import { render, staticRenderFns } from "./InventoryByMonthChart.vue?vue&type=template&id=f2b07cbc&scoped=true&"
import script from "./InventoryByMonthChart.vue?vue&type=script&lang=js&"
export * from "./InventoryByMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b07cbc",
  null
  
)

export default component.exports